export async function glideModelListInit() {
    const elements = document.querySelectorAll('.glide--model-list');
    if (elements.length) {
        let {Breakpoints, Controls, default: Glide, Swipe, Anchors} = await import('@glidejs/glide/dist/glide.modular.esm');
        
        const initializeGlide = (element) => {
            const glide = new Glide(element, {
                type: window.innerWidth < 768 ? 'carousel' : 'slider',
                gap: 45,
                perView: 6,
                bound: true,
                breakpoints: {
                    575: {
                        type: 'carousel',
                        focusAt: 'center',
                        perView: 2,
                        gap: 20
                    },
                    767: {
                        type: 'carousel',
                        focusAt: 'center',
                        perView: 2,
                        gap: 20
                    },
                    1199: {
                        type: 'slider',
                        perView: 6
                    },
                    1459: {
                        type: 'slider',
                        perView: 6
                    }
                }
            });

            const updateArrowsVisibility = () => {
                const currentIndex = glide.index;
                const rightArrow = element.querySelector('.glide__arrow--right');
                const leftArrow = element.querySelector('.glide__arrow--left');
                const totalSlides = element.querySelectorAll('.glide__slide').length;

                if (totalSlides <= glide.settings.perView) {
                  leftArrow.classList.add('hidden');
                  rightArrow.classList.add('hidden');
                } else {
                  leftArrow.classList.remove('hidden');
                  rightArrow.classList.remove('hidden');
                  if (currentIndex === 0) {
                    leftArrow.classList.add('hidden');
                  } else if (currentIndex === totalSlides - glide.settings.perView) {
                    rightArrow.classList.add('hidden');
                  }
                }
            };

            glide.on(['mount.after', 'run.after'], updateArrowsVisibility);
                
            glide.mount({Anchors, Breakpoints, Controls, Swipe});

            element.addEventListener('mouseover', () => {
                const buttons = element.querySelectorAll('.glide__arrow');
                buttons.forEach(btn => {
                    btn.style.display = 'block';
                });
            });
    
            element.addEventListener('mouseout', () => {
                const buttons = element.querySelectorAll('.glide__arrow');
                buttons.forEach(btn => {
                    btn.style.display = 'none';
                });
            });

            return glide;
        };

        const glides = Array.from(elements).map(initializeGlide);

        window.addEventListener('resize', () => {
            glides.forEach(glide => glide.destroy());
            glides.length = 0;
            elements.forEach(element => {
                glides.push(initializeGlide(element));
            });
        });
    }
}